import axios from 'axios';
// export const baseURL= 'http://192.168.0.200:9595';
export const baseURL= 'https://kanadax-backend-final.vercel.app/';


export const httpClient = axios.create({
    baseURL,
});

export default httpClient;